import { configureStore } from '@reduxjs/toolkit'
import user_information from "../Redux/user_information"
import Cart_System from "../Redux/Cart_System"

export default configureStore({
  reducer: {
    user:user_information,
    cart:Cart_System,
  },
})